// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/chevron-right.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/chevron-right'

import { Icon, type IconComponentProps } from '../icon'

export const ChevronRightIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
